import React, { useEffect } from 'react'
import { StorefrontActivityLog } from '../StorefrontActivityLog/StorefrontActivityLog'
import { useStyles } from './Storefront.styles'
import { CollapesBox } from './CollapesBox/CollapesBox'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from '../../../store'
import { getListingIntegrations } from '../../../modules/storefront/action'
import { ListingType } from '../../../modules/storefront/listingCardCreation/types'
import { LoadingLogo } from '@labrav/react-components'
import { LoadingTypes, isLoading as Loading } from '@labrav/common'

export const Storefront: React.FC = () => {
  const { classes } = useStyles()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const isLoading = useSelector<boolean>(state =>
    Loading(state.loading)(LoadingTypes.GENERAL)
  )
  const { search } = useLocation()

  useEffect(() => {
    dispatch(getListingIntegrations())
  }, [dispatch, search])
  const handleButtonCardClick = (id: string) => () => {
    navigate(`buttons/${id}`)
  }

  const handleListingCardClick = (id: string) => () => {
    navigate(`listing-card/${id}`)
  }
  if (isLoading) {
    return <LoadingLogo />
  }

  return (
    <div>
      <div className={classes.container}>
        <div className={classes.formWidth}>
          <div className={classes.colBoxes}>
            <CollapesBox
              handleClick={handleButtonCardClick}
              type={ListingType.BUTTON}
              title={'Buttons'}
            />
            <CollapesBox
              handleClick={handleListingCardClick}
              type={ListingType.LISTING_CARD}
              title={'Listing cards'}
            />
            {/* <CollapesBox title={'Storefronts (Coming soon)'} /> */}
          </div>
        </div>
        <div className={classes.activityLogWidth}>
          <StorefrontActivityLog />
        </div>
      </div>
    </div>
  )
}
